import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";
import CalendarFortnightlyFirst from "./calendars/calendarFortnightlyFirst";
import CalendarFortnightlySecond from "./calendars/calendarFortnightlySecond";
import CalendarMonthly from "./calendars/calendarMonthly";
import CalendarDaily from "./calendars/calendarDaily";
import { renderWithBreaks } from '@utils/translations';

const heroImage = {
  url: `${process.env.CDN_URL}/images/terms-hero-image.jpg`,
  alt: 'Cancellation Policies Hero Image'
};

const ContractTypesTemplate = ({ pageContext: { locale, activeTab, pageSlug } }) => {
  const intl = useIntl();

  const tabs = {
    fortnightly: {
      title: intl.formatMessage({ id: 'Fortnightly' }),
      components: [CalendarFortnightlyFirst, CalendarFortnightlySecond]
    },
    monthly: {
      title: intl.formatMessage({ id: 'Monthly' }),
      components: [CalendarMonthly]
    },
    fixed: {
      title: intl.formatMessage({ id: 'Fixed' }),
      components: [() => renderWithBreaks(intl.formatMessage({ id: 'Contract Type Fixed text' }))]
    },
    daily: {
      title: intl.formatMessage({ id: 'Daily' }),
      components: [CalendarDaily]
    }
  };

  return (
    <Fragment>
      <CustomSEO image={heroImage} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={intl.formatMessage({ id: 'Contract Types' })}
        heroImage={heroImage}
        height={240}
        lazyload={false}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Fragment>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({ id: 'Contract Types' })} - ${title}`;
  const metaDescription = `${intl.formatMessage({ id: 'Contract Types: Fortnightly, Monthly, Fixed, Daily' })}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default ContractTypesTemplate;
